import { Serializable } from "../core";

export class SliderItem implements Serializable<SliderItem> {
  id!: string;
  image!: string;
  link!: string;

  deserialize(json: any): SliderItem {
    this.id = json.id.toString();
    this.image = json.image;
    this.link = json.link;
    return this;
  }
}
